import API from "../global/api";

// Program Settings: jobs an administrator runs by hand. These routes answer
// 401 to anyone else, which the app treats as "logged out" - only a screen
// that has checked the user is an administrator may dispatch them.

// Getting Buyer Status Job (the running update, the last one, recent runs)
export const getBuyerStatusJobRequest = () => {
  return {
    type: "BUYER_STATUS_JOB_REQUEST",
  };
};
export const getBuyerStatusJobSuccess = (data) => {
  return {
    type: "BUYER_STATUS_JOB_SUCCESS",
    payload: data,
  };
};
export const getBuyerStatusJobError = (msg) => {
  return {
    type: "BUYER_STATUS_JOB_ERROR",
    payload: msg,
  };
};
export const getBuyerStatusJob = () => {
  return (dispatch) => {
    dispatch(getBuyerStatusJobRequest());
    return API.get(`/program-settings/buyer-status/status`)
      .then((res) => {
        dispatch(getBuyerStatusJobSuccess(res.data));
        return res.data;
      })
      .catch((error) => {
        dispatch(
          getBuyerStatusJobError(
            error?.response?.data?.message ||
              "Could not read the status of the buyer status update.",
          ),
        );
        return null;
      });
  };
};

// Running Buyer Status Job
export const runBuyerStatusJobRequest = () => {
  return {
    type: "RUN_BUYER_STATUS_JOB_REQUEST",
  };
};
export const runBuyerStatusJobSuccess = (data) => {
  return {
    type: "RUN_BUYER_STATUS_JOB_SUCCESS",
    payload: data,
  };
};
export const runBuyerStatusJobError = (msg) => {
  return {
    type: "RUN_BUYER_STATUS_JOB_ERROR",
    payload: msg,
  };
};
export const runBuyerStatusJob = (handleDangerVisible) => {
  return (dispatch) => {
    dispatch(runBuyerStatusJobRequest());
    return API.post(`/program-settings/buyer-status/run`)
      .then((res) => {
        dispatch(runBuyerStatusJobSuccess(res.data));
      })
      .catch((error) => {
        const message =
          error?.response?.data?.message ||
          "Could not start the buyer status update.";
        dispatch(runBuyerStatusJobError(message));
        handleDangerVisible?.(message);
        // Most likely it is already running: show that run.
        return dispatch(getBuyerStatusJob());
      });
  };
};

// Stopping Buyer Status Job
export const stopBuyerStatusJobRequest = () => {
  return {
    type: "STOP_BUYER_STATUS_JOB_REQUEST",
  };
};
export const stopBuyerStatusJobSuccess = (data) => {
  return {
    type: "STOP_BUYER_STATUS_JOB_SUCCESS",
    payload: data,
  };
};
export const stopBuyerStatusJobError = (msg) => {
  return {
    type: "STOP_BUYER_STATUS_JOB_ERROR",
    payload: msg,
  };
};
export const stopBuyerStatusJob = (handleDangerVisible) => {
  return (dispatch) => {
    dispatch(stopBuyerStatusJobRequest());
    return API.post(`/program-settings/buyer-status/stop`)
      .then((res) => {
        dispatch(stopBuyerStatusJobSuccess(res.data));
      })
      .catch((error) => {
        const message =
          error?.response?.data?.message ||
          "Could not stop the buyer status update.";
        dispatch(stopBuyerStatusJobError(message));
        handleDangerVisible?.(message);
      })
      .then(() => dispatch(getBuyerStatusJob()));
  };
};
